<section class="mc bg-th-white h90" dir="rtl">

  <!-- سربرگ -->
  <header class="mc__head">

    <div class="mc__head-text">
      <h2 class="mc__title">متحرک‌های شما</h2>
      <a class="mc__total" [routerLink]="['/carList']" title="مشاهده فهرست کامل">
        <strong>{{ (carCount > 0 ? carCount : 0) | faNum }}</strong>
        متحرک تحت مدیریت شما
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </a>
    </div>

    <div class="mc__head-actions" role="toolbar" aria-label="ابزارها">

      <button type="button" class="mc__icon-btn mc__icon-btn--excel" title="خروجی اکسل" aria-label="خروجی اکسل" (click)="exportExcel()">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
      </button>

      <button type="button" class="mc__icon-btn" title="راهنما" aria-label="راهنما" (click)="openGuide()">
        <i class="fa fa-question-circle-o" aria-hidden="true"></i>
      </button>

      <button *ngIf="!isDesktop" type="button" class="mc__icon-btn mc__icon-btn--close" title="بستن" aria-label="بستن" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>

    </div>

  </header>

  <!-- نوع نمایش: همه / خدماتی / وقایع ردیاب -->
  <nav class="mc__tabs" role="tablist" aria-label="نوع نمایش">
    <ng-container *ngFor="let tab of scopeTabs">
      <button *ngIf="tab.key !== 'alarms' || hubConnected" type="button" role="tab" class="mc__tab"
        [class.is-active]="scope === tab.key" [attr.aria-selected]="scope === tab.key" (click)="setScope(tab.key)">
        {{ tab.label }}
      </button>
    </ng-container>
  </nav>

  <!-- جستجو و فیلترها (فقط برای لیست خودروها) -->
  <div class="mc__filters" *ngIf="scope !== 'alarms'">

    <label class="mc__search">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input type="text" autocomplete="off" placeholder="جستجو بر اساس نام یا پلاک" aria-label="جستجو بر اساس نام یا پلاک"
        [ngModel]="searchTerm" (ngModelChange)="onSearch($event)">
      <button *ngIf="searchTerm" type="button" class="mc__clear" aria-label="پاک کردن جستجو" (click)="clearSearch()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </label>

    <div class="mc__chips" role="group" aria-label="فیلتر وضعیت">
      <button *ngFor="let chip of statusChips" type="button" class="mc__chip" [attr.data-kind]="chip.key"
        [class.is-active]="statusFilter === chip.key" (click)="setStatusFilter(chip.key)">
        <i class="mc__swatch" aria-hidden="true"></i>
        {{ chip.label }}
        <b *ngIf="chip.key !== 'area'">{{ counts[chip.key] | faNum }}</b>
      </button>
    </div>

    <div class="mc__tools">

      <label class="mc__select mc__select--grow">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <select aria-label="نوع متحرک" [ngModel]="vehicleType" (ngModelChange)="onTypeChange($event)">
          <option value="-1">همه نوع متحرک</option>
          <option *ngFor="let type of vehicleTypes" [value]="type.tiMobileType">{{ type.strComment }}</option>
        </select>
      </label>

      <label class="mc__select" title="مرتب‌سازی">
        <i class="fa fa-sort" aria-hidden="true"></i>
        <select aria-label="مرتب‌سازی" [ngModel]="sortMode" (ngModelChange)="onSortChange($event)">
          <option *ngFor="let option of sortOptions" [value]="option.key">{{ option.label }}</option>
        </select>
      </label>

    </div>

  </div>

  <!-- محتوا -->
  <div class="mc__body">

    <!-- وقایع ردیاب -->
    <ng-container *ngIf="scope === 'alarms'; else vehicles">

      <ul class="mc__list" *ngIf="alarms.length; else noAlarms">
        <li class="alarm" *ngFor="let alarm of alarms">

          <button type="button" class="alarm__main" (click)="focusOnAlarm(alarm)">
            <span class="alarm__icon"><i class="fa fa-bell-o" aria-hidden="true"></i></span>
            <span class="alarm__body">
              <span class="alarm__message">{{ alarm?.strMessage ?? 'نامشخص' }}</span>
              <span class="alarm__time">{{ alarm.strDate | faNum }} {{ alarm.strTime | faNum }}</span>
            </span>
          </button>

          <button type="button" class="mc__icon-btn" title="اطلاعات خودرو در تب جدید" aria-label="اطلاعات خودرو در تب جدید"
            (click)="openVehicleInfo(alarm)">
            <i class="fa fa-external-link" aria-hidden="true"></i>
          </button>

        </li>
      </ul>

      <ng-template #noAlarms>
        <div class="mc__empty">
          <i class="fa fa-bell-o" aria-hidden="true"></i>
          <strong>هنوز رویدادی دریافت نشده</strong>
          <span>رویدادهای جدید ردیاب همین‌جا نمایش داده می‌شوند.</span>
        </div>
      </ng-template>

    </ng-container>

    <!-- لیست خودروها -->
    <ng-template #vehicles>

      <ul class="mc__list" *ngIf="visibleCars.length; else emptyOrLoading">

        <li class="car" *ngFor="let car of visibleCars; let i = index; trackBy: trackByUnit"
          [attr.data-state]="stateOf(car)" [attr.data-flash]="flashOf(car)"
          [class.is-selected]="selectedUnitId === unitIdOf(car)" [class.is-open]="isExpanded(car)">

          <button type="button" class="car__main" (click)="selectCar(car, i)">

            <span class="car__avatar" [title]="stateLabel(car)" (click)="openDetailPage(car); $event.stopPropagation()">
              <i class="fa fa-car" aria-hidden="true"></i>
            </span>

            <span class="car__body">

              <span class="car__top">
                <span class="car__name">{{ displayName(car) }}</span>
                <span class="car__pill">{{ stateLabel(car) }}</span>
              </span>

              <span class="car__status status-badge">{{ car.strDeviceStatus_strComment || '-' }}</span>

              <span class="car__chips">
                <span class="car__plate" *ngIf="car.strVehicleNo">{{ plateOf(car) | faNum }}</span>
                <span class="car__chip" *ngIf="car.iSpeed != null">
                  <i class="fa fa-tachometer" aria-hidden="true"></i>
                  {{ car.iSpeed | faNum }} <bdi>km/h</bdi>
                </span>
                <span class="car__chip">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  {{ car.strTimeAge | faNum }}
                </span>
              </span>

            </span>

          </button>

          <button type="button" class="car__toggle" aria-label="جزئیات بیشتر" [attr.aria-expanded]="isExpanded(car)"
            (click)="toggleDetails(car)">
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </button>

          <div class="car__details" *ngIf="isExpanded(car)">

            <p class="car__type">
              نوع متحرک:
              <strong>{{ car.strMobileType_strComment || '—' }}</strong>
            </p>

            <div class="car__actions">
              <button type="button" (click)="openDetailPage(car)">
                <i class="fa fa-id-card-o" aria-hidden="true"></i>
                جزئیات خودرو
              </button>
              <button type="button" *ngIf="access?.bEnableGeoFance" (click)="openAreaAnalysis(car)">
                <img src="../../../assets/Img/polygon-icon-28-min.png" width="16" height="16" alt="">
                تحلیل در محدوده
              </button>
            </div>

          </div>

        </li>

      </ul>

      <ng-template #emptyOrLoading>

        <div class="mc__skeletons" *ngIf="isLoading; else noResult" aria-hidden="true">
          <span *ngFor="let n of [1, 2, 3, 4, 5, 6]"></span>
        </div>

        <ng-template #noResult>
          <div class="mc__empty">
            <i class="fa fa-car" aria-hidden="true"></i>
            <strong>متحرکی پیدا نشد</strong>
            <span>جستجو یا فیلترها را تغییر دهید.</span>
            <button *ngIf="hasActiveFilters" type="button" (click)="resetFilters()">پاک کردن فیلترها</button>
          </div>
        </ng-template>

      </ng-template>

    </ng-template>

  </div>

  <!-- پایین لیست -->
  <footer class="mc__foot">
    <ng-container *ngIf="scope === 'alarms'; else carsFoot">
      {{ alarms.length | faNum }} رویداد اخیر
    </ng-container>
    <ng-template #carsFoot>
      <ng-container *ngIf="cars">
        نمایش <b>{{ visibleCars.length | faNum }}</b>
        <ng-container *ngIf="statusFilter !== 'area'"> از <b>{{ counts.all | faNum }}</b></ng-container>
        متحرک
      </ng-container>
    </ng-template>
  </footer>

</section>
